import React, { useState } from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import withStores from '@studionand/ada-next/src/stores/withStores';
import Welcome from '../WelcomeAfterLogin';
import Link from '../Link';
import useStores from '../../utils/useStores';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
    height: '60vh',
  },
}));

const Logo = props => {
  const classes = useStyles(props);
  return <img className={classes.logo} {...props} />;
};

const Login = props => {
  const { loginStore, getInitialProps, afterSubmit } = props;
  const { uiStore } = useStores();
  const classes = useStyles(props);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleChangeUsername = e => {
    setUsername(e.target.value);
  };

  const handleChangePassword = e => {
    setPassword(e.target.value);
  };

  const handleSubmit = e => {
    e.preventDefault();
    loginStore.loginAsync(username, password).then(res => {
      if (res.status === 200) {
        getInitialProps && getInitialProps();
      }
      afterSubmit && afterSubmit();
    });
  };

  const disableButton = username.length === 0 || password.length === 0;
  const isRequesting = loginStore.status === 'pending';

  const linkContext =
    process.env.NODE_ENV === 'production' ? '/' : `/enplus/${uiStore.context}/`;

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={2} sm={3} md={4} />
        <Grid item xs={8} sm={6} md={4}>
          <Box display="flex" flexDirection="column" mt={8}>
            <Typography
              variant="h3"
              color="primary"
              gutterBottom
              align="center"
            >
              <b>Login</b>
            </Typography>
            {!loginStore.isLoggedIn && (
              <React.Fragment>
                <Typography variant="body1" gutterBottom align="center">
                  Loggen Sie sich hier ein und genießen Sie erweiterten Zugriff
                  auf News, Informationen und Downloads.
                </Typography>
                <form onSubmit={handleSubmit}>
                  <Box display="flex" flexDirection="column">
                    <TextField
                      value={username}
                      onChange={handleChangeUsername}
                      label="Name"
                      margin="normal"
                      variant="filled"
                    />
                    <TextField
                      value={password}
                      type="password"
                      onChange={handleChangePassword}
                      label="Password"
                      margin="normal"
                      variant="filled"
                    />
                    <Box pl={1.5}>
                      <Link
                        href={`${linkContext}forgot-password`}
                        target="_blank"
                        variant="caption"
                        color="textSecondary"
                      >
                        Passwort vergessen?
                      </Link>
                    </Box>
                    {isRequesting ? (
                      <Box mt={2} mx="auto">
                        <CircularProgress />
                      </Box>
                    ) : (
                      <Box mt={2} textAlign="center">
                        <Button
                          type="submit"
                          variant="outlined"
                          disabled={disableButton}
                        >
                          Anmelden
                        </Button>
                      </Box>
                    )}
                  </Box>
                </form>
              </React.Fragment>
            )}
            {loginStore.isLoggedIn && <Welcome />}
          </Box>
        </Grid>
        <Grid item xs={2} sm={3} md={4} />
      </Grid>
    </div>
  );
};

Login.defaultProps = {
  onLogin: () => {},
  isLoggedIn: false,
};

export default withStores('loginStore')(Login);
